import options from './access.component';

export default {
    selector: 'dtAccessManagement',
    options
};



// WEBPACK FOOTER //
// ./app/common/access-management/index.js